import PopupTableBtn from "@/components/ik/form/button/PopupTableBtn.vue"

export default {
  components: { PopupTableBtn }
}
